import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const AuraCustom = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        highlight: {
          background: '#007EF4', // Blue-500 Pipeup
          color: '#ffffff',
          hoverBackground: '#0069CB', // Blue-600 Pipeup
          hoverColor: '#ffffff',
          focusBackground: '#007EF4',
          focusColor: '#ffffff',
        },
      },
      dark: {
        highlight: {
          background: '#007EF4', // Blue-500 Pipeup
          color: '#ffffff',
          hoverBackground: '#0069CB', // Blue-600 Pipeup
          hoverColor: '#ffffff',
          focusBackground: '#007EF4',
          focusColor: '#ffffff',
        },
      },
    },
  },
});

export default AuraCustom;

